import type { OrganisationMachine } from '../api/types'
import { clockOf, dayLabel } from '../room/format'

const seenAt = (machine: OrganisationMachine) =>
  machine.runner_off_since === null ? -Infinity : Date.parse(machine.runner_off_since)

/**
 * The machine whose runner the sidebar speaks for: one that can start agents
 * when any can, the default first, and otherwise the default, the one seen
 * last, or the first.
 */
export function machineShown(machines: readonly OrganisationMachine[]): OrganisationMachine | null {
  if (machines.length === 0) return null
  const online = machines.filter((machine) => machine.runner_online)
  if (online.length > 0) return online.find((machine) => machine.default) ?? online[0]
  return machines.find((machine) => machine.default)
    ?? machines.reduce((latest, machine) => (seenAt(machine) > seenAt(latest) ? machine : latest))
}

/** "off since 14:02", with the day when it was not today, or "not started" for a runner never seen. */
export function runnerDown(machine: OrganisationMachine): string {
  const since = machine.runner_off_since
  if (since === null) return 'not started'
  const day = dayLabel(since)
  if (day === 'Today') return `off since ${clockOf(since)}`
  // Mid-sentence, so "yesterday"; a month name keeps its capital.
  return `off since ${day === 'Yesterday' ? 'yesterday' : day} ${clockOf(since)}`
}
